import {
  Component,
  HostBinding,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'backoffice-generate-multiple-reports-button',
  templateUrl: './generate-multiple-reports-button.component.html',
  styleUrls: ['./generate-multiple-reports-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GenerateMultipleReportsButtonComponent {
  @Input() isGeneratingMultipleReports!: boolean;
  @HostBinding('class.disabled')
  @Input()
  disabled!: boolean;
}
